import { Flex } from "antd";
import Brand from "../../../components/Brand";
import BalanceCard from "./components/BalanceCard";
import BarcodeCard from "./components/BarcodeCard";
import MemberAccordion from "./components/MemberAccordion";
import MemberDescription from "./components/MemberDescription";
import SummaryCard from "./components/SummaryCard";
import React, { useContext, useEffect, useState } from "react";
import { memberType } from "../../../types/member";
import { MemberContext } from "../../../context/MemberProvider.tsx";

type ProfileProps = {
  previewData?: memberType;
  platform?: string | null;
};

const Profile: React.FC<ProfileProps> = ({
  previewData,
  platform: platformProp,
}: ProfileProps) => {
  const { memberData, platform: contextPlatform } = useContext(MemberContext);
  // The admin preview renders Profile outside MemberProvider, so the context
  // platform is null there. Let the caller pass the real platform explicitly;
  // fall back to context for the live member card.
  const platform = platformProp ?? contextPlatform;

  const [data, setData] = useState<memberType | null>(null);

  useEffect(() => {
    if (previewData) {
      setData(previewData);
      return;
    }
    setData(memberData);
  }, [memberData, previewData]);

  return (
    data && (
      <Flex
        vertical
        gap={12}
        className="pt-[12px]"
        data-testid="profile"
        style={previewData && { background: data.background_color }}
      >
        <Brand
          preview={!!previewData}
          url={previewData ? previewData.logo : data.logo}
        />
        <Flex vertical gap={20} className="p-4 pb-[50px] pt-0 shadow-cards">
          <BarcodeCard data={data} preview={!!previewData} />
          {data.is_enabled_annual_consumption && (
            <BalanceCard data={data} platform={platform} />
          )}
          <SummaryCard data={data} />
          <MemberDescription data={data} preview={!!previewData} />
          <MemberAccordion data={data} preview={!!previewData} />
        </Flex>
      </Flex>
    )
  );
};
export default Profile;
